"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("./utils");

var _default = _react.default.createClass({
  displayName: "FormattedHTMLMessage",
  mixins: [_utils.I18nCommonMixin],
  propTypes: _utils.commonPropTypes,
  render: function render() {
    var __message = this.props.message;
    var props = (0, _utils.classNameFix)((0, _utils.getPassThroughProps)(this.props)); // must use dangerouslySetInnerHTML prop to display embedded HTML

    return _react.default.createElement("i18n-string", (0, _extends2.default)({}, props, {
      dangerouslySetInnerHTML: {
        __html: this._getValue()
      }
    }));
  }
});

exports.default = _default;
module.exports = exports.default;